module.exports = __webpack_public_path__ + "assets/img/more-btn-aae40472.png";